import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";

const TopPlansChart = () => {
  const [filter, setFilter] = useState("This Month");

  // 👉 You can later change data based on filter
  const getSeries = () => {
    if (filter === "This Week") return [50, 30, 20];
    if (filter === "Today") return [40, 35, 25];
    return [60, 20, 20]; // Default: This Month
  };

  const series = getSeries();

  const options = {
    chart: { type: "donut" },
    labels: ["Basic", "Premium", "Enterprise"],
    colors: ["#f97316", "#facc15", "#2f7de1"],
    legend: { show: false },
    dataLabels: { enabled: false },
    stroke: { width: 0 },
    plotOptions: {
      pie: {
        donut: { size: "65%" },
      },
    },
  };

  return (
    <Card
      className="shadow-sm border-0 d-flex flex-column m-0"
      style={{ borderRadius: "14px" }}
    >
      <Card.Header className="bg-white border-0 d-flex justify-content-between align-items-center">
        <h5 className="fw-semibold mb-0">Top Plans</h5>

        <Dropdown align="end">
          <Dropdown.Toggle size="sm" variant="light" className="border">
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {["This Month", "This Week", "Today"].map((item) => (
              <Dropdown.Item
                key={item}
                onClick={() => setFilter(item)}
                active={filter === item}
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body className="text-center flex-grow-1">
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height={280}
        />

        <div className="d-flex justify-content-between mt-3 px-3">
          <span>
            <span style={{ color: "#f97316" }}>●</span> Basic
          </span>
          <span>{series[0]}%</span>
        </div>

        <div className="d-flex justify-content-between px-3">
          <span>
            <span style={{ color: "#facc15" }}>●</span> Premium
          </span>
          <span>{series[1]}%</span>
        </div>

        <div className="d-flex justify-content-between px-3">
          <span>
            <span style={{ color: "#2f7de1" }}>●</span> Enterprise
          </span>
          <span>{series[2]}%</span>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TopPlansChart;